import HomePage from "@system/config/home-page";
import Api from "./APIHandler";
import Constants from "src/helper/Constants";
import { __remove, __set } from "src/store/axios_indicator";

const { speedBoats } = Constants
const API = new Api({});
class HomePageContentAPICall {

    getContentTabCount = async (params) => {
        let reqData = {
            data: { ...params, selectedSpeedBoat: speedBoats.AMERICA, "filterBy": [], "contentType": "" }
        };

        let res = {};
        await API.post(HomePage.CONTENT_TAB_COUNT_NEW, reqData).then((response) => {
            res = response.data.data;
        });
        return res;
    };

    getHomePageContent = async (params) => {
        let res = {};
        let param = {}
        param.data = { ...params, selectedSpeedBoat: speedBoats.AMERICA, ...(!params.filterBy && { filterBy: [] }) }
        await API.post(HomePage.ALL_CONTENT_TAB, param).then((resHer) => {
            res = resHer.data;
        }).catch((e) => {
        })
        return res;
    }
}

export default HomePageContentAPICall;